














































































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";

import VuetifySelectItems from "@/types/app/vuetifySelectItems";

import compareTo from "@/utils/compareTo";
import formatMoney from "@/utils/formatMoney";
import formatDate from "@/utils/formatDate";
import Endpoint from "@/utils/endpoint";
import AccountService from "@/services/accountService";
import CustomerService from "@/services/customerService";
import Customer from "@/types/customer/Customer";
import AccountInterface, { accountInitialValue } from "@/types/app/accounts";
import { Watch } from "vue-property-decorator";
import ErrorService from "@/services/erroService";
import BaseComponent from "@/utils/baseComponent";

const namespace = "account";

interface ProductFund {
  fundName: string;
  fundSiteName: string;
  fundId: string;
}

@Component({
  data: () => ({
    formType: "",
    account: accountInitialValue,
    required: (v: any) => !!v || "This field is required",
  }),
  watch: {
    accountEdit: function (newVal: AccountInterface, oldVal) {
      //to work with changes in someOtherProp
      if (newVal.id) {
        this.$data.formType = "view";
        this.$data.account = newVal;
      } else {
        this.$data.formType = "new";
        this.$data.account = accountInitialValue;
      }
    },
  },
})
export default class ModalDetail extends BaseComponent {
  @Getter("getModalNewAccountState", { namespace })
  modalNewAccountState!: boolean;

  @Action("setModalNewAccountState", { namespace })
  setModalNewAccountState!: any;

  @Action("setModalDeleteState", { namespace }) setModalDeleteState!: any;

  @Getter("getLoading", { namespace }) loading!: boolean;
  @Getter("getAccountSent", { namespace }) accountSent!: boolean;
  @Getter("getAccountState", { namespace })
  accountEdit!: AccountInterface;

  @Action("setLoading", { namespace }) setLoading!: any;

  @Action("setAccountSent", { namespace })
  setAccountSent!: any;

  private endpoint = new Endpoint();

  items: VuetifySelectItems[] = [];

  customersAccount: VuetifySelectItems[] = [];
  newCustomersIn: any[] = [];
  funds: VuetifySelectItems[] = [];
  account: AccountInterface = accountInitialValue;
  private accountService = new AccountService(this.$http);
  customerService = new CustomerService(this.$http);
  accounts: AccountInterface[] = [];
  formatDate = formatDate;
  formatMoney = formatMoney;
  formType = "new";
  accountLoading = false;

  showEdit(): void {
    this.formType = "edit";
    this.account.fund = this.funds.find((f: any) => f.value == this.account.fundId);
    this.account.user = this.customersAccount.find(
      (f: any) => f.value == this.account.userId
    );
  }

  @Watch("modalNewAccountState")
  async loadingWhenNew() {

    if (this.modalNewAccountState) {
      const [fundResponse, _, accountResponse] = await Promise.all([
        this.getProductFunds(),
        this.getCustomers(),
        this.accountService.getAccounts(),
      ]);
      this.funds = fundResponse;
      this.accounts = accountResponse;
    }
  }

  validationAccount(item: AccountInterface) {
    const valid = { valid: true, message: "" };
    if (!item.fundId) {
      valid.message += "Fund name not found. ";
      valid.valid = false;
    }
    if (
      this.formType != "edit" &&
      this.accounts.some(
        (x) =>
          x.accountNumber == item.accountNumber &&
          x.fundId == item.fundId &&
          x.userId == item.userId
      )
    ) {
      valid.message = `User ${item.email} with account number ${item.accountNumber} and fund name ${item.fundName} already exist. `;
      valid.valid = false;
    }
    return valid;
  }

  async makeANewAccount() {
    if (this.form().validate()) {
      this.account.email = this.account?.user?.data?.email;
      this.account.userId = this.account?.user?.value;

      this.account.fundName = this.account?.fund?.text;
      this.account.fundId = this.account?.fund?.value;
      const resValid = this.validationAccount(this.account);

      if (!resValid.valid) {
        console.log(this.account);
        this.showError(resValid.message);
        return;
      }
      this.accountLoading = true;

      try {
        const url = this.endpoint.account;
        const { user, fund, returnedInWallet, ...dataAccount } = this.account;
        const success = await this.accountService.saveAccount(
          dataAccount as AccountInterface,
          this.formType == "edit"
        );
        if (success) {
          this.showAccountSentModal();
          this.clearFields();
          this.closeModal();
        }
      } catch (error) {
        ErrorService.onError(error);
      } finally {
        this.accountLoading = false;
      }
    }
  }

  closeModal(): void {
    this.clearFields();
    this.setModalNewAccountState(false);
  }

  showAccountSentModal() {
    this.setAccountSent(true);
  }

  clearFields() {
    this.account.userId = this.account.fundId = this.account.accountNumber = "";
    this.form().reset();
  }

  async getProductFunds(): Promise<VuetifySelectItems[]> {
    const url = this.endpoint.productFund;
    const response = await this.$http.get(`${url}?hasInvestment=false`);
    const productFunds = response.data as ProductFund[];
    const productFundsOrdened = productFunds.sort((a, b) =>
      compareTo(a.fundSiteName, b.fundSiteName)
    );

    const itemsForVuetifySelect = productFundsOrdened.map((productFund) => ({
      text: productFund.fundSiteName,
      value: productFund.fundId,
      data: productFund,
    }));

    return itemsForVuetifySelect;
  }

  async getCustomers(): Promise<void> {

    this.customersAccount = await this.customerService.getSelectAccountCustomers();
   
    this.newCustomersIn.push({ header: 'Clients' });
    this.customersAccount.filter(x => x.group == 'Clients').forEach(element => {
      this.newCustomersIn.push(element);
    });
    this.newCustomersIn.push({ divider: true });

    const groups = this.customersAccount.filter(x => x.group != 'Clients').map(item => item.group)
      .filter((value, index, self) => self.indexOf(value) === index)

    groups.forEach(group => {
      this.newCustomersIn.push({ header: group });
      this.customersAccount.filter(x => x.group == group).forEach(customer => {
        this.newCustomersIn.push(customer);
      })
      this.newCustomersIn.push({ divider: true });
    })


    console.log('getCustomers', this.newCustomersIn);
  }
}
